import Actions from './Actions';
import Body from './Body';
import CloseButton from './CloseButton';
import Content, { type ContentProps } from './Content';
import { Form } from './Form';
import Header from './Header';
import ResourceGuard, { type ResourceGuardProps } from './ResourceGuard';
import Root, {
  type BaseDialogProps,
  type ControlledDialogProps,
  type RootHandlers,
  type RootProps,
  type StaticDialogProps,
} from './Root';
import SubmitError from './SubmitError';
import Subtitle from './Subtitle';
import Title from './Title';
import Trigger from './Trigger';
import TriggerButtonIcon, {
  type TriggerButtonIconProps,
} from './TriggerButtonIcon';

export type { RootHandlers as DialogRootHandlers };
export type { RootProps as DialogRootProps };
export type { ControlledDialogProps as DialogControlledProps };
export type { StaticDialogProps as DialogStaticProps };
export type { BaseDialogProps as DialogBaseProps };
export type { ContentProps as DialogContentProps };
export type { TriggerButtonIconProps };
export type { ResourceGuardProps as DialogResourceGuardProps };
export { useDialogContext } from './context';

export const DialogComposite = {
  Root,
  Content,
  Form,
  Header,
  Title,
  Subtitle,
  CloseButton,
  Body,
  Actions,
  ResourceGuard,
  Trigger,
  TriggerButtonIcon,
  SubmitError,
};
